import { render, staticRenderFns } from "./UserNameLogin.vue?vue&type=template&id=2c6ba132&scoped=true&"
import script from "./UserNameLogin.vue?vue&type=script&lang=js&"
export * from "./UserNameLogin.vue?vue&type=script&lang=js&"
import style0 from "./UserNameLogin.vue?vue&type=style&index=0&id=2c6ba132&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6ba132",
  null
  
)

export default component.exports